export const REGEXES = {
  EMAIL:
    /^(?:[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)*)@(?:(?:[A-Za-z0-9]+-?)*[A-Za-z0-9]+\.)+[A-Za-z]{2,63}$/,
  PASSWORD:
    /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\s])|(?=.*[a-z])(?=.*[0-9])(?=.*[^\w\s])|(?=.*[A-Z])(?=.*[0-9])(?=.*[^\w\s])).{8,}$/,
  URL: /^https?:\/\/(?:www\.|(?!www))[^\s.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,}$/,
  HTTPS_URL:
    /^https:\/\/(?:www\.|(?!www))[^\s.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,}$/,
  PHONE_NUMBER: /^[+]?\d+$/,
  IS_NUMBER_REGEX: /^[0-9\b]+$/,
  IS_TIME_ZONE: /^[+-][01][0-9]:[0-5][0-9]$/,
  IS_COMMA_SEPARATED_EMAIL:
    /^[\W]*((?:[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)*)@(?:(?:[A-Za-z0-9]+-?)*[A-Za-z0-9]+\.)+[A-Za-z]{2,63}[\W]*,{1}[\W]*)*((?:[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)*)@(?:(?:[A-Za-z0-9]+-?)*[A-Za-z0-9]+\.)+[A-Za-z]{2,63})[\W]*$/
};
